// Feature flags for phased rollout.
//
// These flags gate UI entry points for features that are built but not yet
// being offered to users. Nothing is deleted — flip a flag back to `true`
// to re-enable the feature everywhere it is gated.

export const FEATURE_FLAGS = {
  // Lynx AI Study Buddy — dashboard tab, home tile, learning-style CTA,
  // and support-chat redirect. Flip off to hide every entry point again.
  studyBuddy: true,
  // Lynx webcam / Full Experience. Parked until the video path is refined.
  // Chat + music still work when this is false.
  lynxVideo: false,
  // Student dashboard Study Resources tab — hidden until ready to ship.
  // When false, the tab and home-tile entry point are hidden; the tab
  // component stays in the codebase so it can be re-enabled later.
  studyResources: false,
  // Community job board — built, hidden until ~1,000 MAU.
  // When false, public listing/detail/post pages 404 and nav/footer/sitemap
  // omit the board. Admin review stays available so staff can vet listings.
  jobBoard: false,
} as const;

export const STUDY_BUDDY_ENABLED = FEATURE_FLAGS.studyBuddy;
export const LYNX_VIDEO_ENABLED = FEATURE_FLAGS.lynxVideo;
export const STUDY_RESOURCES_ENABLED = FEATURE_FLAGS.studyResources;
export const JOB_BOARD_ENABLED = FEATURE_FLAGS.jobBoard;
